import {
    server
} from "@/api";


const prefix = 'api/bookmarks'

export const paginate = async (data = {}) => {
    return await server().get(prefix, { params: data })
}

export const store = async (data) => {
    return await server().post(prefix, data)
}

export const toggle = async (data) => {
    return await server().put(prefix + '/toggle', data)
}

export const destroy = async (id) => {
    return await server().delete(prefix + '/' + id)
}

const bookmarksApi = {
    paginate,
    store,
    toggle,
    destroy
}

export default bookmarksApi;